var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-list",
        { attrs: { separator: "" } },
        [
          _c(
            "q-item",
            [
              _c("q-item-main", {
                attrs: { label: "czy rozróżniać małe i duże litery" }
              }),
              _c(
                "q-item-side",
                { attrs: { right: "" } },
                [
                  _c("q-toggle", {
                    model: {
                      value: _vm.searchData.isCaseSensitive,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "isCaseSensitive", $$v)
                      },
                      expression: "searchData.isCaseSensitive"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-item",
            [
              _c("q-item-main", {
                attrs: { label: "czy wyszukiwać wg regexp" }
              }),
              _c(
                "q-item-side",
                { attrs: { right: "" } },
                [
                  _c("q-toggle", {
                    model: {
                      value: _vm.searchData.isRegexp,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "isRegexp", $$v)
                      },
                      expression: "searchData.isRegexp"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.getUser_groups_ApplicationDevelopers
            ? _c(
                "q-collapsible",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("q-item-side", [
                        _c("img", {
                          attrs: {
                            src:
                              "/icormanager/images/icons/silk/icons/database_table.png"
                          }
                        })
                      ]),
                      _c("q-item-main", { attrs: { label: "Tabele" } })
                    ],
                    1
                  ),
                  _c("i-q-field", {
                    attrs: { label: "nazwa", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.tableName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "tableName", $$v)
                      },
                      expression: "searchData.tableName"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "grupa", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.tableGroup,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "tableGroup", $$v)
                      },
                      expression: "searchData.tableGroup"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "opis", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.tableDescription,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "tableDescription", $$v)
                      },
                      expression: "searchData.tableDescription"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "treść SQL", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.tableSQL,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "tableSQL", $$v)
                      },
                      expression: "searchData.tableSQL"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: {
                      label: "szablon XSL - obiekt",
                      ispaste: "",
                      iscopy: ""
                    },
                    model: {
                      value: _vm.searchData.tableXSL,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "tableXSL", $$v)
                      },
                      expression: "searchData.tableXSL"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: {
                      label: "szablon XSL - tabela",
                      ispaste: "",
                      iscopy: ""
                    },
                    model: {
                      value: _vm.searchData.tableXSLTable,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "tableXSLTable", $$v)
                      },
                      expression: "searchData.tableXSLTable"
                    }
                  }),
                  _c("q-field", [
                    _c(
                      "div",
                      { staticClass: "row no-wrap" },
                      [
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID od" },
                          model: {
                            value: _vm.searchData.tableOIDFrom,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "tableOIDFrom", $$v)
                            },
                            expression: "searchData.tableOIDFrom"
                          }
                        }),
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID do" },
                          model: {
                            value: _vm.searchData.tableOIDTo,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "tableOIDTo", $$v)
                            },
                            expression: "searchData.tableOIDTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-item-separator", { attrs: { inset: "" } }),
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              icon: "search",
                              color: "primary",
                              dense: "",
                              size: "md",
                              label: "szukaj"
                            },
                            on: { click: _vm.doSearchTable }
                          }),
                          _c("q-btn", {
                            attrs: {
                              icon: "clear",
                              color: "negative",
                              dense: "",
                              size: "md",
                              outline: "",
                              label: "wyczyść"
                            },
                            on: { click: _vm.doResetTable }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.getUser_groups_ApplicationDevelopers
            ? _c(
                "q-collapsible",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("q-item-side", [
                        _c("img", {
                          attrs: {
                            src:
                              "/icormanager/images/icons/silk/icons/page_white_code_red.png"
                          }
                        })
                      ]),
                      _c("q-item-main", {
                        attrs: { label: "Wyszukiwarki i formularze XML" }
                      })
                    ],
                    1
                  ),
                  _c("i-q-field", {
                    attrs: { label: "nazwa", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.xmlName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "xmlName", $$v)
                      },
                      expression: "searchData.xmlName"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "grupa", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.xmlGroup,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "xmlGroup", $$v)
                      },
                      expression: "searchData.xmlGroup"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "treść XML", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.xmlSource,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "xmlSource", $$v)
                      },
                      expression: "searchData.xmlSource"
                    }
                  }),
                  _c("q-field", [
                    _c(
                      "div",
                      { staticClass: "row no-wrap" },
                      [
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID od" },
                          model: {
                            value: _vm.searchData.xmlOIDFrom,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "xmlOIDFrom", $$v)
                            },
                            expression: "searchData.xmlOIDFrom"
                          }
                        }),
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID do" },
                          model: {
                            value: _vm.searchData.xmlOIDTo,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "xmlOIDTo", $$v)
                            },
                            expression: "searchData.xmlOIDTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-item-separator", { attrs: { inset: "" } }),
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              icon: "search",
                              color: "primary",
                              dense: "",
                              size: "md",
                              label: "szukaj"
                            },
                            on: { click: _vm.doSearchXML }
                          }),
                          _c("q-btn", {
                            attrs: {
                              icon: "clear",
                              color: "negative",
                              dense: "",
                              size: "md",
                              outline: "",
                              label: "wyczyść"
                            },
                            on: { click: _vm.doResetXML }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.getUser_groups_ApplicationDevelopers
            ? _c(
                "q-collapsible",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("q-item-side", [
                        _c("img", {
                          attrs: {
                            src: "/icormanager/images/icons/silk/icons/book.png"
                          }
                        })
                      ]),
                      _c("q-item-main", { attrs: { label: "Rozdziały" } })
                    ],
                    1
                  ),
                  _c("i-q-field", {
                    attrs: { label: "nagłówek", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.chapterName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "chapterName", $$v)
                      },
                      expression: "searchData.chapterName"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: {
                      label: "nagłówek w menu",
                      ispaste: "",
                      iscopy: ""
                    },
                    model: {
                      value: _vm.searchData.chapterNameMenu,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "chapterNameMenu", $$v)
                      },
                      expression: "searchData.chapterNameMenu"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "href", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.chapterHRef,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "chapterHRef", $$v)
                      },
                      expression: "searchData.chapterHRef"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "href w menu", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.chapterHRefMenu,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "chapterHRefMenu", $$v)
                      },
                      expression: "searchData.chapterHRefMenu"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "opis", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.chapterDescription,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "chapterDescription", $$v)
                      },
                      expression: "searchData.chapterDescription"
                    }
                  }),
                  _c("q-field", [
                    _c(
                      "div",
                      { staticClass: "row no-wrap" },
                      [
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID od" },
                          model: {
                            value: _vm.searchData.chapterOIDFrom,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "chapterOIDFrom", $$v)
                            },
                            expression: "searchData.chapterOIDFrom"
                          }
                        }),
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID do" },
                          model: {
                            value: _vm.searchData.chapterOIDTo,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "chapterOIDTo", $$v)
                            },
                            expression: "searchData.chapterOIDTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-item-separator", { attrs: { inset: "" } }),
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              icon: "search",
                              color: "primary",
                              dense: "",
                              size: "md",
                              label: "szukaj"
                            },
                            on: { click: _vm.doSearchChapter }
                          }),
                          _c("q-btn", {
                            attrs: {
                              icon: "clear",
                              color: "negative",
                              dense: "",
                              size: "md",
                              outline: "",
                              label: "wyczyść"
                            },
                            on: { click: _vm.doResetChapter }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.getUser_groups_ApplicationDevelopers
            ? _c(
                "q-collapsible",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("q-item-side", [
                        _c("img", {
                          attrs: {
                            src:
                              "/icormanager/images/icons/silk/icons/script_lightning.png"
                          }
                        })
                      ]),
                      _c("q-item-main", { attrs: { label: "Zdarzenia" } })
                    ],
                    1
                  ),
                  _c("i-q-field-select", {
                    attrs: {
                      label: "źródło zdarzeń",
                      options: _vm.optionsEventOwner
                    },
                    model: {
                      value: _vm.searchData.eventOwner,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "eventOwner", $$v)
                      },
                      expression: "searchData.eventOwner"
                    }
                  }),
                  _c("i-q-field-select", {
                    attrs: {
                      label: "rodzaj zdarzenia",
                      options: _vm.optionsEventKind
                    },
                    model: {
                      value: _vm.searchData.eventKind,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "eventKind", $$v)
                      },
                      expression: "searchData.eventKind"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "klucz", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.eventKey,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "eventKey", $$v)
                      },
                      expression: "searchData.eventKey"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "opis", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.eventDescription,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "eventDescription", $$v)
                      },
                      expression: "searchData.eventDescription"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "treść", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.eventSource,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "eventSource", $$v)
                      },
                      expression: "searchData.eventSource"
                    }
                  }),
                  _c("q-field", [
                    _c(
                      "div",
                      { staticClass: "row no-wrap" },
                      [
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID od" },
                          model: {
                            value: _vm.searchData.eventOIDFrom,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "eventOIDFrom", $$v)
                            },
                            expression: "searchData.eventOIDFrom"
                          }
                        }),
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID do" },
                          model: {
                            value: _vm.searchData.eventOIDTo,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "eventOIDTo", $$v)
                            },
                            expression: "searchData.eventOIDTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-item-separator", { attrs: { inset: "" } }),
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              icon: "search",
                              color: "primary",
                              dense: "",
                              size: "md",
                              label: "szukaj"
                            },
                            on: { click: _vm.doSearchEvent }
                          }),
                          _c("q-btn", {
                            attrs: {
                              icon: "clear",
                              color: "negative",
                              dense: "",
                              size: "md",
                              outline: "",
                              label: "wyczyść"
                            },
                            on: { click: _vm.doResetEvent }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.getUser_groups_ApplicationDevelopers
            ? _c(
                "q-collapsible",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("q-item-side", [
                        _c("img", {
                          attrs: {
                            src: "/icormanager/images/icons/silk/icons/html.png"
                          }
                        })
                      ]),
                      _c("q-item-main", {
                        attrs: { label: "HTML Użytkownika" }
                      })
                    ],
                    1
                  ),
                  _c("i-q-field", {
                    attrs: { label: "nazwa", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.htmlName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "htmlName", $$v)
                      },
                      expression: "searchData.htmlName"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "opis", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.htmlDescription,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "htmlDescription", $$v)
                      },
                      expression: "searchData.htmlDescription"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "treść HTML", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.htmlSource,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "htmlSource", $$v)
                      },
                      expression: "searchData.htmlSource"
                    }
                  }),
                  _c("q-field", [
                    _c(
                      "div",
                      { staticClass: "row no-wrap" },
                      [
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID od" },
                          model: {
                            value: _vm.searchData.htmlOIDFrom,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "htmlOIDFrom", $$v)
                            },
                            expression: "searchData.htmlOIDFrom"
                          }
                        }),
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID do" },
                          model: {
                            value: _vm.searchData.htmlOIDTo,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "htmlOIDTo", $$v)
                            },
                            expression: "searchData.htmlOIDTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-item-separator", { attrs: { inset: "" } }),
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              icon: "search",
                              color: "primary",
                              dense: "",
                              size: "md",
                              label: "szukaj"
                            },
                            on: { click: _vm.doSearchHTML }
                          }),
                          _c("q-btn", {
                            attrs: {
                              icon: "clear",
                              color: "negative",
                              dense: "",
                              size: "md",
                              outline: "",
                              label: "wyczyść"
                            },
                            on: { click: _vm.doResetHTML }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.getUser_groups_ApplicationDevelopers
            ? _c(
                "q-collapsible",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("q-item-side", [
                        _c("img", {
                          attrs: {
                            src:
                              "/icormanager/images/icons/silk/icons/script.png"
                          }
                        })
                      ]),
                      _c("q-item-main", { attrs: { label: "SQL Użytkownika" } })
                    ],
                    1
                  ),
                  _c("i-q-field", {
                    attrs: { label: "nazwa SQL", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.sqlName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "sqlName", $$v)
                      },
                      expression: "searchData.sqlName"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "grupa", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.sqlGroup,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "sqlGroup", $$v)
                      },
                      expression: "searchData.sqlGroup"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "treść SQL", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.sqlSource,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "sqlSource", $$v)
                      },
                      expression: "searchData.sqlSource"
                    }
                  }),
                  _c("q-field", [
                    _c(
                      "div",
                      { staticClass: "row no-wrap" },
                      [
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID od" },
                          model: {
                            value: _vm.searchData.sqlOIDFrom,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "sqlOIDFrom", $$v)
                            },
                            expression: "searchData.sqlOIDFrom"
                          }
                        }),
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID do" },
                          model: {
                            value: _vm.searchData.sqlOIDTo,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "sqlOIDTo", $$v)
                            },
                            expression: "searchData.sqlOIDTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-item-separator", { attrs: { inset: "" } }),
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              icon: "search",
                              color: "primary",
                              dense: "",
                              size: "md",
                              label: "szukaj"
                            },
                            on: { click: _vm.doSearchSQL }
                          }),
                          _c("q-btn", {
                            attrs: {
                              icon: "clear",
                              color: "negative",
                              dense: "",
                              size: "md",
                              outline: "",
                              label: "wyczyść"
                            },
                            on: { click: _vm.doResetSQL }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.getUser_groups_ApplicationDevelopers
            ? _c(
                "q-collapsible",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("q-item-side", [
                        _c("img", {
                          attrs: {
                            src:
                              "/icormanager/images/icons/silk/icons/layout.png"
                          }
                        })
                      ]),
                      _c("q-item-main", { attrs: { label: "Wzorce stron" } })
                    ],
                    1
                  ),
                  _c("i-q-field", {
                    attrs: { label: "nazwa wzorca", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.templateName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "templateName", $$v)
                      },
                      expression: "searchData.templateName"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "treść", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.templateSource,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "templateSource", $$v)
                      },
                      expression: "searchData.templateSource"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "zmienne XML", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.templateXML,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "templateXML", $$v)
                      },
                      expression: "searchData.templateXML"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: { label: "XSL - końcowy", ispaste: "", iscopy: "" },
                    model: {
                      value: _vm.searchData.templateXSLAtEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "templateXSLAtEnd", $$v)
                      },
                      expression: "searchData.templateXSLAtEnd"
                    }
                  }),
                  _c("i-q-field", {
                    attrs: {
                      label: "XSL - główny obiekt",
                      ispaste: "",
                      iscopy: ""
                    },
                    model: {
                      value: _vm.searchData.templateXSLMainObjectAtEnd,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.searchData,
                          "templateXSLMainObjectAtEnd",
                          $$v
                        )
                      },
                      expression: "searchData.templateXSLMainObjectAtEnd"
                    }
                  }),
                  _c("q-field", [
                    _c(
                      "div",
                      { staticClass: "row no-wrap" },
                      [
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID od" },
                          model: {
                            value: _vm.searchData.templateOIDFrom,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "templateOIDFrom", $$v)
                            },
                            expression: "searchData.templateOIDFrom"
                          }
                        }),
                        _c("q-input", {
                          staticClass: "col",
                          attrs: { "float-label": "OID do" },
                          model: {
                            value: _vm.searchData.templateOIDTo,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "templateOIDTo", $$v)
                            },
                            expression: "searchData.templateOIDTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-item-separator", { attrs: { inset: "" } }),
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-main",
                        [
                          _c("q-btn", {
                            staticClass: "q-mr-sm",
                            attrs: {
                              icon: "search",
                              color: "primary",
                              dense: "",
                              size: "md",
                              label: "szukaj"
                            },
                            on: { click: _vm.doSearchTemplate }
                          }),
                          _c("q-btn", {
                            attrs: {
                              icon: "clear",
                              color: "negative",
                              dense: "",
                              size: "md",
                              outline: "",
                              label: "wyczyść"
                            },
                            on: { click: _vm.doResetTemplate }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }